import { Card, Tabs } from 'antd';
import React from 'react';

import { EmergencyScenarioTableFragment } from '../../../graphql/api/generated';
import { PermissionKey_enum } from '../../../graphql/hasura/generated';
import { authentication } from '../../../stores';

import { EmergencyScenarioAccessPointsManager } from './EmergencyScenarioAccessPointsManager';

interface IEmergencyScenarioTabsProps {
  emergencyScenario: EmergencyScenarioTableFragment;
}

export const EmergencyScenarioTabs: React.FC<IEmergencyScenarioTabsProps> = (props) => {
  const { emergencyScenario } = props;

  if (!authentication.hasPermission(PermissionKey_enum.AccessPoint_Read)) {
    return null;
  }

  return (
    <Card bordered={false}>
      <Tabs animated={false}>
        <Tabs.TabPane key='ACCESS_POINTS' tab='Access Points'>
          <EmergencyScenarioAccessPointsManager
            emergencyScenario={emergencyScenario}
            readOnly={!authentication.hasPermission(PermissionKey_enum.EmergencyScenario_Manage)}
          />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  );
};
